import { Injectable, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatchMakingService } from '@fantaz/shared/data-access/api';
import {
  CasualTournamentDetails,
  CasualTournamentEntity,
  EventSchedule,
  Game,
  TournamentPass,
} from '@fantaz/shared/data-access/models';
import { Store } from '@ngrx/store';
import * as PlayTournamentActions from './play-tournament.actions';
import { getIsPlayStarting } from './play-tournament.selectors';

@Injectable({
  providedIn: 'root',
})
export class PlayTournamentFacade {
  store: Store = inject(Store);
  matchMakingService: MatchMakingService = inject(MatchMakingService);

  isPlayStarting = toSignal(this.store.select(getIsPlayStarting));

  /**
   * Play tournament
   *
   * @param options
   */
  playTournament(options: {
    entryAmount: number;
    pass?: TournamentPass | string | null | undefined;
    zboOnly?: boolean;
    game: Game;
    eventCode?: string;
    openTournament: CasualTournamentDetails | CasualTournamentEntity;
    eventSchedule: EventSchedule;
  }) {
    this.store.dispatch(PlayTournamentActions.playTournament(options));
  }

  /**
   * Try game for free tournament
   *
   * @param options.tournament CasualTournamentDetails
   */
  tryForFreeTournament(options: { name: string; game: any }) {
    // TODO: Move for actions
    const url = this.matchMakingService.getFreeGameUrl(options);
    window.location.href = url;
  }
}
